import { Box, Button, Modal, styled } from "@mui/material";

export const Styled = {
    Modal: styled(Modal)`
        display: flex;
        align-items: center;
        justify-content: center;
    `,
    Content: styled(Box)`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
        border-radius: 12px;
        background-color: ${props => props.theme.palette.secondary.main};
        border: 2px solid ${props => props.theme.palette.secondary.light};
        max-width: 500px;
    `,
    Button: styled(Button)`
        margin: 0px 10px;
    `,
};
